import script from "./DashboardFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardFooter.vue?vue&type=script&setup=true&lang=js"

import "./DashboardFooter.vue?vue&type=style&index=0&id=bd9bdeb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd9bdeb2"]])

export default __exports__